import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold" }, "Work Experience", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  class: "border-black text-center text-2xl",
  "data-hr-content": "",
  style: {"--bg":"white","--p":"0 10px","--trans-x":"-50%","--trans-y":"-50%"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkExperienceEntry = _resolveComponent("WorkExperienceEntry")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workExperienceDetails, (entry) => {
      return (_openBlock(), _createBlock(_component_WorkExperienceEntry, {
        key: entry.title,
        title: entry.title,
        companyName: entry.companyName,
        address: entry.address,
        duration: entry.duration,
        details: entry.details
      }, null, 8, ["title", "companyName", "address", "duration", "details"]))
    }), 128))
  ], 64))
}